import { render, staticRenderFns } from "./TableModule1020.vue?vue&type=template&id=37d7aa88&scoped=true"
import script from "./TableModule1020.vue?vue&type=script&lang=js"
export * from "./TableModule1020.vue?vue&type=script&lang=js"
import style0 from "./TableModule1020.vue?vue&type=style&index=0&id=37d7aa88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d7aa88",
  null
  
)

export default component.exports